/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
import { friendsAndFamilyListInput } from '../../../dataActions/DataActionExtension.g';
import { rsmFriendsAndFamilyListResponseExtensionClass } from '../../../dataActions/DataServiceEntities.g';

/**
 * Getfriendsandfamilylist Input Action
 */
export class GetFriendsAndFamilyListInput implements Msdyn365.IActionInput {
    public input: IDataServiceRequest;
    constructor(input: IDataServiceRequest) {
        this.input = input;
    }
    public shouldCacheOutput = () => false;

    public getCacheKey = () => `IGetFriendsAndFamilyListInput`;
    public getCacheObjectType = () => 'IGetFriendsAndFamilyListInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetFriendsAndFamilyListInput(
        friendsAndFamilyListInput()
    );
};

async function action(input: GetFriendsAndFamilyListInput, ctx: Msdyn365.IActionContext): Promise<rsmFriendsAndFamilyListResponseExtensionClass> {
    return input.input.execute(ctx);

    // TEST DATA: remove when module is done
    // return {
    //     Status: 'SUCCESS',
    //     Result: {
    //         Codes: [
    //             {
    //                 RecipientEmailAddress: '',
    //                 Status: 'SENT',
    //                 Code: 'uam97FAL3h',
    //                 SentDate: '2020-08-20',
    //                 ActivationDate: ''
    //             },
    //             {
    //                 RecipientEmailAddress: 'fred.wwwww@email.com',
    //                 Status: 'ACTIVATED',
    //                 Code: 'FCuA2fVAVc',
    //                 SentDate: '2020-08-20',
    //                 ActivationDate: '2020-08-20'
    //             },
    //             {
    //                 RecipientEmailAddress: 'fred.awdawdaw@email.com',
    //                 Status: 'ACTIVATED',
    //                 Code: 'xgtU6J0ojU',
    //                 SentDate: '2020-08-20',
    //                 ActivationDate: '2020-08-20'
    //             },
    //             {
    //                 RecipientEmailAddress: 'fred.aiabwdiubw@email.com',
    //                 Status: 'ACTIVATED',
    //                 Code: 'vmh78AqCor',
    //                 SentDate: '2020-08-20',
    //                 ActivationDate: '2020-08-20'
    //             },
    //             {
    //                 RecipientEmailAddress: '',
    //                 Status: 'SENT',
    //                 Code: '1JMiVTfkNs',
    //                 SentDate: '2020-08-20',
    //                 ActivationDate: ''
    //             },
    //         ]
    //     }
    // };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<rsmFriendsAndFamilyListResponseExtensionClass>>action,
    input: createInput
});
